export function sendGaEvent (eventName) {
  if (process.env.NODE_ENV === 'production' && window.gtag) {
    window.gtag('event', eventName)
  }
}
